import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientBarCodeModalComponent } from 'src/app/shared/components/patient-bar-code-modal/patient-bar-code-modal.component';
import { AdministrationTypeEnum } from 'src/app/shared/enum/prescription.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { UserGetNameService } from 'src/app/shared/services/API/user/user-get-name.service';
import { ListUserStruct } from 'src/app/shared/services/structs/user/list-user.struct';
import { ObservationMedicineBarCodeModalComponent } from '../../observation-medicine-bar-code-modal/observation-medicine-bar-code-modal.component';
import { PrescricptionCheckHistoryModalComponent } from './prescricption-check-history-modal/prescricption-check-history-modal.component';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { AllergyModel } from 'src/app/shared/services/models/medical-record/allergy.model';
import { KitWithItemsStruct } from 'src/app/shared/services/structs/pharmacy/kit-with-items.struct';
import { KitItemsModalComponent } from 'src/app/shared/components/kit-items-modal/kit-items-modal.component';
import { SuspendPrescriptionScheduleModalComponent } from 'src/app/shared/components/suspend-prescription-schedule-modal/suspend-prescription-schedule-modal.component';
import { StatusSchedulingEnum } from 'src/app/shared/enum/medical-record/status-scheduling.enum';
import { FrequencyEnum } from 'src/app/shared/enum/medical-record/frequency.enum';
import { UtilService } from 'src/app/shared/services/util.service';
import { UserRoleEnum } from 'src/app/shared/enum/user-role.enum';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { GetMedicineRequest } from 'src/app/shared/services/requests/pharmacy/get-medicine.request';
import { PrescriptionMedicineCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine-check.struct';
import { PrescriptionSolutionCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-check.struct';
import { MedicineLinkedKitService } from 'src/app/shared/services/API/pharmacy/medicine-linked-kit.service';
import { VerifyPermissionResponse } from 'src/app/shared/services/responses/user/verify-permission.response';
import { PrescriptionObservationOnBed } from 'src/app/shared/services/models/medical-record/prescription-observation-on-bed.model';
import { PrescriptionObservationOnBedEnum } from 'src/app/shared/enum/medical-record/prescription-observation-on-bed.enum';
import { AdministrationLocationEnum } from 'src/app/shared/enum/pharmacy/administration-location.enum';

@Component({
    selector: 'app-prescription-modal',
    templateUrl: './prescription-modal.component.html',
    styleUrls: ['./prescription-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionModalComponent>,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    public userGetNameService: UserGetNameService,
    private utilService: UtilService,
    private medicineLinkedKitService: MedicineLinkedKitService,
  ) { }

  public model: FormGroup;

  public isLoading: boolean = false;
  public showLocal: boolean = false;
  public checkedPatient: boolean = false;
  public showComplaints: boolean = false;
  public checkedMedicine: boolean = false;
  public isReadonly: boolean = false;
  public canSuspend: boolean = false;
  public useScheduling: boolean = false;
  public isMedicatedSolution: boolean = false;
  public completelyNonDispensated: boolean = false;
  public modelIsDisable: boolean = false;
  public isPrescriptionExternal: boolean = false;

  public openedStatus = PrescriptionStatusEnum.EmAberto;
  public releasedStatus = PrescriptionStatusEnum.Liberado;
  public nonDispensedStatus = PrescriptionStatusEnum.NaoDispensado;
  public suspended = PrescriptionStatusEnum.Suspenso;
  public statusSchedulingEnum: typeof StatusSchedulingEnum = StatusSchedulingEnum;
  public prescriptionObservationOnBedEnum: typeof PrescriptionObservationOnBedEnum = PrescriptionObservationOnBedEnum;

  public user: ListUserStruct;
  public prescriptionCheckStruct: any;
  // public thisMedicalPrescriptionCheck: MedicalPrescriptionCheckStruct;

  public listKit: KitWithItemsStruct[] = [];
  public allergiesToSave: AllergyModel[] = this.data.allergiesToSave ? this.data.allergiesToSave : [];
  public listPrescriptionObservationOnBed: PrescriptionObservationOnBed[] = [];

  public checkDatetimeFulfilled: Date;
  public checkDatetimeFulfilledTemp: Date = null;

  public checkUserName: string;
  public reasonSuspension: string;
  public observationSelect: number;
  public administrationLocationExternal: number = AdministrationLocationEnum.ExternaCasa;
  public checkProfessionName: string;

  public prescriptionMedicineStruct: PrescriptionMedicineStruct;
  public prescriptionSolutionStruct: PrescriptionSolutionStruct;
  public verifyPermissionResponse: VerifyPermissionResponse = this.data.verifyPermissionResponse;

  public idStatusScheduling: number;
  public idNextPrescriptionSolutionCheck: number;
  public idNextPrescriptionMedicineCheck: number;
  public frequencyNow: number = FrequencyEnum.agora;
  public selectedKitIds:Set<number> = new Set<number>();

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      checkName: ['', [Validators.required]],
      checkMedication: ['', [Validators.required]],
      checkAdministration: ['', [Validators.required]],
      administrationLocal: [''],
      hasPatientDenied: [''],
      hasComplaints: [''],
      complaints: [''],
    });

    if (this.data != null && this.data.isMedicatedSolution != null)
      this.isMedicatedSolution = this.data.isMedicatedSolution;

    if (this.data != null && this.data.listPrescriptionObservationOnBed != null)
      this.listPrescriptionObservationOnBed = this.data.listPrescriptionObservationOnBed;

    if(this.isMedicatedSolution){
      this.prescriptionSolutionStruct = this.data.prescription;
      this.prescriptionSolutionStruct.listSelectedIdKit.forEach(idKit => this.selectedKitIds.add(idKit));
      this.idNextPrescriptionSolutionCheck = this.prescriptionSolutionStruct.idNextPrescriptionSolutionCheck;
    }
    else{
      this.prescriptionMedicineStruct = this.data.prescription;
      this.prescriptionMedicineStruct.listSelectedIdKit.forEach(idKit => this.selectedKitIds.add(idKit));
      this.idNextPrescriptionMedicineCheck = this.prescriptionMedicineStruct.idNextPrescriptionMedicineCheck;
    }
    
    if (this.data.useScheduling != null)
      this.useScheduling = this.data.useScheduling;

    if (this.data.selectedPrescriptionCheck)
      this.prescriptionCheckStruct = this.data.selectedPrescriptionCheck;

    this.searchKits();

    if (this.prescriptionCheckStruct && this.prescriptionCheckStruct != null){
      this.populatePrescriptionCheck();
    } else {
      if (this.isMedicatedSolution && this.prescriptionSolutionStruct.prescriptionSolution.idAdministrationType != AdministrationTypeEnum.naoDefinida)
        this.model.get('administrationLocal').setValue(this.prescriptionSolutionStruct.administrationTypeName)
      else if (!this.isMedicatedSolution && this.prescriptionMedicineStruct.prescriptionMedicine.idAdministrationType != AdministrationTypeEnum.naoDefinida)
        this.model.get('administrationLocal').setValue(this.prescriptionMedicineStruct.administrationTypeName)
    }

    this.canSuspend = this.utilService.getRoles().some(x => x.idRole === UserRoleEnum.checagem_suspender_horário) || this.utilService.getToken().isMaster;

    this.verifyCompleteNonDispensation();
    
    this.isPrescriptionExternal = ((!this.isMedicatedSolution && this.prescriptionMedicineStruct?.prescriptionMedicine?.idLookupAdministrationLocation != null && this.prescriptionMedicineStruct?.prescriptionMedicine?.idLookupAdministrationLocation === this.administrationLocationExternal)
    || (this.isMedicatedSolution && (this.prescriptionSolutionStruct.prescriptionSolution.idLookupAdministrationLocation != null && this.prescriptionSolutionStruct.prescriptionSolution.idLookupAdministrationLocation === this.administrationLocationExternal)));

    if (this.data.actions && this.isPrescriptionExternal){
      this.alertService.show('Alerta!', 'Prescrição com administração externa, disponível apenas para visualização.', AlertType.warning);
      this.isReadonly = true;
    }
    if ((this.isMedicatedSolution && this.prescriptionSolutionStruct.idPrescriptionStatus == this.suspended)
      || (!this.isMedicatedSolution && this.prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus == this.suspended) || this.isPrescriptionExternal) {
      this.model.disable();
      this.modelIsDisable = true;
    }
  }

  submit() {
    if(this.isLoading)
      return;

    if((this.isMedicatedSolution && this.prescriptionSolutionStruct.idPrescriptionStatus == this.nonDispensedStatus)
      || (!this.isMedicatedSolution && this.prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus == this.nonDispensedStatus)){
      this.alertService.show('Erro', 'Essa precrição foi não dispensada pela farmácia e não pode ser checada', AlertType.error);
      return;
    }
    if (!this.isFormValid()) {
      this.alertService.show('Erro', 'É necessário verificar (marcar) todos os itens para realizar a liberação', AlertType.error);
      return;
    }
    this.isLoading = true;
    if(this.isMedicatedSolution){
      this.matDialogRef.close({ prescriptionSolutionCheckStruct: this.mapSolutionToRequest() });
    } else {
      this.matDialogRef.close({ prescriptionMedicineCheckStruct: this.mapMedicineToRequest() });
    }
  }

  private isFormValid(): boolean {
    return this.model.valid && this.model.get('checkName').value && this.model.get('checkMedication').value && this.model.get('checkAdministration').value;
  }

  private hasAllergyInMedicineList(): boolean {
    return this.prescriptionSolutionStruct?.listSolutionMedicine?.some(medicine => medicine.patientHasAllergy) ?? false;
  }

  private getAllergyMedicines(): string[] {
    return this.prescriptionSolutionStruct.listSolutionMedicine
      ?.filter(medicine => medicine.patientHasAllergy)
      .map(medicine => medicine.medicineName) ?? [];
  }

  private createAllergyDescription(allergyMedicines: string[]): string {
    if (allergyMedicines.length > 0) {
      return `O paciente é alérgico a um dos princípios ativos deste medicamento: ${allergyMedicines}. \nDeseja prosseguir com a checagem?`;
    }
    else if (allergyMedicines.length > 1) {
      return `O paciente é alérgico a um ou mais princípios ativos destes medicamentos: ${allergyMedicines.join(', ')}. \nDeseja prosseguir com a checagem?`;
    }
    return 'O paciente é alérgico a um dos princípios ativos deste medicamento. \nDeseja prosseguir com a checagem?';
  }

  private showAllergyWarning(description: string) {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        hasImage: true,
        isTwoButtonsModal: true,
        title: 'Atenção!',
        description: description
      }
    });
    return dialogRef.afterClosed();
  }

  getPrescriptionCheckData() {
    this.checkDatetimeFulfilled = this.isMedicatedSolution ? this.prescriptionCheckStruct.prescriptionSolutionCheck : this.prescriptionCheckStruct?.prescriptionMedicineCheck.datetimeCheckFulfilled;
    this.checkProfessionName = this.prescriptionCheckStruct.professionName;
    this.checkUserName = this.prescriptionCheckStruct.userName;

    if (this.prescriptionMedicineStruct?.patientHasAllergy || this.hasAllergyInMedicineList()) {
      const allergyMedicines = this.getAllergyMedicines();
      const description = this.createAllergyDescription(allergyMedicines);
      this.showAllergyWarning(description).subscribe(result => {
        if (!result?.confirm)
          this.close();
      });
    }
    else if (this.allergiesToSave && this.allergiesToSave.length > 0) {
      let allergyDetected: boolean = false;

      allergyDetected = this.data.listMedicine.some((medicine) =>
        medicine.listAllergy?.some((allergyId) =>
          this.allergiesToSave.some((savedAllergy) => savedAllergy.idAllergy === allergyId)
        )
      );
      if (allergyDetected) {
        const description = this.createAllergyDescription([]);

        this.showAllergyWarning(description).subscribe(result => {
          if (!result?.confirm)
            this.close();
        });
      }
    }
  }

  mapMedicineToRequest(): PrescriptionMedicineCheckStruct {
    let presciptionMedicineCheckStruct: PrescriptionMedicineCheckStruct = new PrescriptionMedicineCheckStruct();
    
    if(this.prescriptionCheckStruct) {
      presciptionMedicineCheckStruct.prescriptionMedicineCheck.datetimeCheckFulfilled = this.prescriptionCheckStruct.prescriptionMedicineCheck.datetimeCheckFulfilled;
      presciptionMedicineCheckStruct.professionName = this.prescriptionCheckStruct.professionName;
      presciptionMedicineCheckStruct.userName = this.prescriptionCheckStruct.userName;
      presciptionMedicineCheckStruct.prescriptionStatus = this.prescriptionCheckStruct.prescriptionStatus;
      presciptionMedicineCheckStruct.isBeforeActualSchedulingCycle = this.prescriptionCheckStruct.isBeforeActualSchedulingCycle;
    }

    presciptionMedicineCheckStruct.prescriptionMedicineCheck.checkAdministration = this.model.get('checkAdministration').value ? this.model.get('checkAdministration').value : false;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.administrationLocal = this.model.get('administrationLocal').value ? this.model.get('administrationLocal').value : null;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.checkMedication = this.model.get('checkMedication').value ? this.model.get('checkMedication').value : false;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.checkName = this.model.get('checkName').value ? this.model.get('checkName').value : false;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.complaints = this.model.get('complaints').value ? this.model.get('complaints').value : null;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.hasComplaints = this.model.get('hasComplaints').value ? this.model.get('hasComplaints').value : false;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.hasPatientDenied = this.model.get('hasPatientDenied').value ? this.model.get('hasPatientDenied').value : false;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.idPrescriptionMedicineCheck = this.prescriptionCheckStruct?.prescriptionMedicineCheck.idPrescriptionMedicineCheck ? this.prescriptionCheckStruct.prescriptionMedicineCheck.idPrescriptionMedicineCheck : this.idNextPrescriptionMedicineCheck;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.idPrescriptionMedicine = this.prescriptionMedicineStruct?.prescriptionMedicine.idPrescriptionMedicine;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.reasonSuspension = this.reasonSuspension;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.idStatusScheduling = this.idStatusScheduling ? this.idStatusScheduling : this.statusSchedulingEnum.Concluido;
    presciptionMedicineCheckStruct.prescriptionMedicineCheck.datetimeCheckEstimative = this.prescriptionCheckStruct?.prescriptionMedicineCheck.datetimeCheckEstimative;
    presciptionMedicineCheckStruct.prescriptionObservationOnBed = this.observationSelect ? this.listPrescriptionObservationOnBed.find(x => x.idPrescriptionObservationOnBed == this.observationSelect).description : "";

    this.prescriptionCheckStruct = presciptionMedicineCheckStruct;
    this.prescriptionMedicineStruct.tempCheck = true;

    //TO DO: Criação de log (variáveis que eram usadas para log no banco na estrutura antiga)
    // if (this.verifyPermissionResponse) {
    //   presciptionMedicineCheckStruct.idUserAuthorization = this.verifyPermissionResponse.idUser;
    //   presciptionMedicineCheckStruct.idUserRequest = this.verifyPermissionResponse.idUserRequest;
    //   presciptionMedicineCheckStruct.justification = this.verifyPermissionResponse.justification;
    // }

    return presciptionMedicineCheckStruct;
  }

  mapSolutionToRequest(): PrescriptionSolutionCheckStruct {
    let presciptionSolutionCheckStruct: PrescriptionSolutionCheckStruct = new PrescriptionSolutionCheckStruct();
        
    if(this.prescriptionCheckStruct) {
      presciptionSolutionCheckStruct.prescriptionSolutionCheck.datetimeCheckFulfilled = this.prescriptionCheckStruct.prescriptionSolutionCheck.datetimeCheckFulfilled;
      presciptionSolutionCheckStruct.professionName = this.prescriptionCheckStruct.professionName;
      presciptionSolutionCheckStruct.userName = this.prescriptionCheckStruct.userName;
      presciptionSolutionCheckStruct.prescriptionStatus = this.prescriptionCheckStruct.prescriptionStatus;
      presciptionSolutionCheckStruct.isBeforeActualSchedulingCycle = this.prescriptionCheckStruct.isBeforeActualSchedulingCycle;
    }

    presciptionSolutionCheckStruct.prescriptionSolutionCheck.checkAdministration = this.model.get('checkAdministration').value ? this.model.get('checkAdministration').value : false;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.administrationLocal = this.model.get('administrationLocal').value ? this.model.get('administrationLocal').value : null;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.checkMedication = this.model.get('checkMedication').value ? this.model.get('checkMedication').value : false;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.checkName = this.model.get('checkName').value ? this.model.get('checkName').value : false;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.complaints = this.model.get('complaints').value ? this.model.get('complaints').value : null;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.hasComplaints = this.model.get('hasComplaints').value ? this.model.get('hasComplaints').value : false;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.hasPatientDenied = this.model.get('hasPatientDenied').value ? this.model.get('hasPatientDenied').value : false;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.idPrescriptionSolutionCheck = this.prescriptionCheckStruct?.prescriptionSolutionCheck.idPrescriptionSolutionCheck ? this.prescriptionCheckStruct.prescriptionSolutionCheck.idPrescriptionSolutionCheck : this.idNextPrescriptionSolutionCheck;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.idPrescriptionSolution = this.prescriptionSolutionStruct?.prescriptionSolution.idPrescriptionSolution;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.reasonSuspension = this.reasonSuspension;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.idStatusScheduling = this.idStatusScheduling ? this.idStatusScheduling : this.statusSchedulingEnum.Concluido;
    presciptionSolutionCheckStruct.prescriptionSolutionCheck.datetimeCheckEstimative = this.prescriptionCheckStruct?.prescriptionSolutionCheck.datetimeCheckEstimative;
    presciptionSolutionCheckStruct.prescriptionObservationOnBed = this.observationSelect ? this.listPrescriptionObservationOnBed.find(x => x.idPrescriptionObservationOnBed == this.observationSelect).description : "";

    this.prescriptionCheckStruct = presciptionSolutionCheckStruct;
    this.prescriptionSolutionStruct.tempCheck = true;

    return presciptionSolutionCheckStruct;
  }

  checkAdministration(event) {
    this.showLocal = event.checked;
  }

  selectionChange() {
    if (this.observationSelect == this.prescriptionObservationOnBedEnum.Queixas) {
      this.showComplaints = true;
      this.model.get('hasComplaints').setValue(true);
      this.model.get('hasPatientDenied').setValue(false);

      this.model.get('checkName').setValidators([Validators.required]);
      this.model.get('checkName').updateValueAndValidity();
      this.model.get('checkMedication').setValidators([Validators.required]);
      this.model.get('checkMedication').updateValueAndValidity();
      this.model.get('checkAdministration').setValidators([Validators.required]);
      this.model.get('checkAdministration').updateValueAndValidity();
      this.model.get('complaints').setValidators([Validators.required]);
      this.model.get('complaints').updateValueAndValidity();
    }
    else if (this.observationSelect == this.prescriptionObservationOnBedEnum.PacienteNegouMedicacao) {
      this.showComplaints = false;
      this.model.get('hasComplaints').setValue(false);
      this.model.get('hasPatientDenied').setValue(true);

      this.model.get('checkName').setValidators(null);
      this.model.get('checkName').updateValueAndValidity();
      this.model.get('checkMedication').setValidators(null);
      this.model.get('checkMedication').updateValueAndValidity();
      this.model.get('checkAdministration').setValidators(null);
      this.model.get('checkAdministration').updateValueAndValidity();
      this.model.get('complaints').setValidators(null);
      this.model.get('complaints').updateValueAndValidity();
    }
    else {
      this.showComplaints = false;
      this.model.get('hasComplaints').setValue(false);
      this.model.get('hasPatientDenied').setValue(false);

      this.model.get('checkName').setValidators([Validators.required]);
      this.model.get('checkName').updateValueAndValidity();
      this.model.get('checkMedication').setValidators([Validators.required]);
      this.model.get('checkMedication').updateValueAndValidity();
      this.model.get('checkAdministration').setValidators([Validators.required]);
      this.model.get('checkAdministration').updateValueAndValidity();
      this.model.get('complaints').setValidators(null);
      this.model.get('complaints').updateValueAndValidity();
    }
  }

  populatePrescriptionCheck() {
    let populateStruct = this.isMedicatedSolution ? this.prescriptionCheckStruct?.prescriptionSolutionCheck : this.prescriptionCheckStruct?.prescriptionMedicineCheck;
    this.model.get('hasComplaints').setValue(populateStruct.hasComplaints);
    this.model.get('complaints').setValue(populateStruct.complaints)
    this.model.get('hasPatientDenied').setValue(populateStruct.hasPatientDenied);
    this.model.get('checkName').setValue(populateStruct.checkName);
    this.model.get('checkMedication').setValue(populateStruct.checkMedication);
    this.model.get('checkAdministration').setValue(populateStruct.checkAdministration);
    this.model.get('administrationLocal').setValue(populateStruct.administrationLocal)

    const minDate = new Date('0001-01-01T00:00:00').getTime();
    const datetimeCheckEstimative = new Date(populateStruct?.datetimeCheckEstimative).getTime();

    populateStruct.datetimeCheckEstimative =
      datetimeCheckEstimative === minDate ? new Date()
        : populateStruct?.datetimeCheckEstimative;

    this.showLocal = populateStruct.checkAdministration;
    this.showComplaints = populateStruct.hasComplaints;
    if (populateStruct.hasComplaints == true)
      this.observationSelect = this.prescriptionObservationOnBedEnum.Queixas;
    else if (populateStruct.hasPatientDenied == true)
      this.observationSelect = this.prescriptionObservationOnBedEnum.PacienteNegouMedicacao;
    else
      this.observationSelect = null;

    this.isReadonly = (populateStruct.datetimeCheckFulfilled != null || (!this.isMedicatedSolution && this.prescriptionMedicineStruct.tempCheck) || (this.isMedicatedSolution && this.prescriptionSolutionStruct.tempCheck));
    if (this.isReadonly) {
      this.model.get('hasComplaints').disable();
      this.model.get('complaints').disable();
      this.model.get('hasPatientDenied').disable();
      this.model.get('checkName').disable();
      this.model.get('checkMedication').disable();
      this.model.get('checkAdministration').disable();
      this.model.get('administrationLocal').disable();
    }
    this.getPrescriptionCheckData();

    if ((!this.isMedicatedSolution && this.prescriptionMedicineStruct.tempCheck) || (this.isMedicatedSolution && this.prescriptionSolutionStruct.tempCheck))
      this.checkDatetimeFulfilledTemp = new Date();
  }

  close() {
    this.matDialogRef.close();
  }

  openMedicineBarCodeModal(idMedicine: number) {
    const dialogRef = this.dialog.open(ObservationMedicineBarCodeModalComponent, {
      data: {
        idMedicine: idMedicine,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.checkMedicine) {
        this.model.get('checkMedication').setValue(true);
      }
    });
  }
  openPatientBarCodeModal() {
    const dialogRef = this.dialog.open(PatientBarCodeModalComponent, {
      data: {
        idEpisode: this.data.idEpisode,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.checkPatient) {
        this.model.get('checkName').setValue(true);
      }
    });
  }

  statusIdToText(status: number): string {
    if (status == 1)
      return "Medicação Próxima";
    else if (status == 2)
      return "Medicação Adiantada";
    else if (status == 3)
      return "Medicação Atrasada";
  }

  openCheckHistoryModal() {
    this.dialog.open(PrescricptionCheckHistoryModalComponent, {
      data: {
        isMedicatedSolution: this.isMedicatedSolution,
        listPrescriptionCheck: this.isMedicatedSolution ? this.prescriptionSolutionStruct.listSolutionCheck : this.prescriptionMedicineStruct.listPrescriptionMedicineCheck,
      },
    });
  }

  openKit(kit: KitWithItemsStruct) {
    const dialogRef = this.dialog.open(KitItemsModalComponent, {
      width: "700px",
      data: {
        kit: kit
      },
    });
  }

  suspendPrescriptionModal() {
    const dialogRef = this.dialog.open(SuspendPrescriptionScheduleModalComponent, {
      width: "600px"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm && result.reasonSuspension) {
        this.reasonSuspension = result.reasonSuspension;
        this.idStatusScheduling = StatusSchedulingEnum.Suspenso;

        if(this.isMedicatedSolution){
          this.matDialogRef.close({ prescriptionSolutionCheckStruct: this.mapSolutionToRequest() });
        } else {
          this.matDialogRef.close({ prescriptionMedicineCheckStruct: this.mapMedicineToRequest() });
        }
      }
    });
  }

  verifyCompleteNonDispensation(){
    if(!this.isMedicatedSolution && this.prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus == this.nonDispensedStatus){
      this.completelyNonDispensated = true;
      this.isReadonly = true;
      this.model.get('hasComplaints').disable();
      this.model.get('complaints').disable();
      this.model.get('hasPatientDenied').disable();
      this.model.get('checkName').disable();
      this.model.get('checkMedication').disable();
      this.model.get('checkAdministration').disable();
      this.model.get('administrationLocal').disable();
    }
    else if(this.isMedicatedSolution){
      let listPrescription = this.prescriptionSolutionStruct.listSolutionMedicine;
      
      this.completelyNonDispensated = listPrescription.every(obj => obj.prescriptionSolutionMedicine.idPrescriptionStatus == this.nonDispensedStatus);
      if(this.completelyNonDispensated){
        this.isReadonly = true;
        this.model.get('hasComplaints').disable();
        this.model.get('complaints').disable();
        this.model.get('hasPatientDenied').disable();
        this.model.get('checkName').disable();
        this.model.get('checkMedication').disable();
        this.model.get('checkAdministration').disable();
        this.model.get('administrationLocal').disable();
      }
    }
  }

  searchKits() {
    let getMedicineRequest = new GetMedicineRequest();
    
    if(this.isMedicatedSolution)
      getMedicineRequest.listIdMedicine = this.prescriptionSolutionStruct.listSolutionMedicine.map(x => x.prescriptionSolutionMedicine.idMedicine);
    else
      getMedicineRequest.listIdMedicine.push(this.prescriptionMedicineStruct.prescriptionMedicine.idMedicine);

    this.medicineLinkedKitService.getWithItemsByIdMedicine(getMedicineRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          return;
        }

        if (response && response.listKit && response.listKit.length > 0)
          this.listKit = response.listKit;
        else
          this.listKit = [];
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  isKitSelected(item: KitWithItemsStruct): boolean {
    return this.selectedKitIds.has(item.kit.idKit);
  }

  toggleKitSelection(item: KitWithItemsStruct): void {
    const id = item.kit.idKit;
    if (this.selectedKitIds.has(id)) {
      this.selectedKitIds.delete(id);
    } else {
      this.selectedKitIds.clear(); // remove this if you want multi-select
      this.selectedKitIds.add(id);
    }
  }
}